// LivPure Mock Data
// This file contains mock data for the LivPure customer onboarding dashboard

// Define regions and cities
const regions = {
    "North": ["Delhi", "Chandigarh", "Lucknow", "Jaipur"],
    "North 1": ["Delhi", "Gurugram", "Noida", "Ghaziabad"],
    "North 2": ["Chandigarh", "Amritsar", "Ludhiana", "Shimla"],
    "East": ["Kolkata", "Patna", "Bhubaneswar", "Guwahati"],
    "East 1": ["Kolkata", "Howrah", "Siliguri", "Asansol"],
    "East 2": ["Patna", "Ranchi", "Jamshedpur", "Guwahati"],
    "West": ["Mumbai", "Pune", "Ahmedabad", "Surat"],
    "West 1": ["Mumbai", "Thane", "Navi Mumbai", "Pune"],
    "West 2": ["Ahmedabad", "Surat", "Vadodara", "Rajkot"],
    "South": ["Chennai", "Bangalore", "Hyderabad", "Kochi"],
    "South 1": ["Chennai", "Coimbatore", "Madurai", "Pondicherry"],
    "South 2": ["Bangalore", "Hyderabad", "Kochi", "Thiruvananthapuram"]
  };
  
  // Categories relevant to LivPure
  const categories = [
    "Product Quality", 
    "Price & Value", 
    "Customer Service", 
    "Delivery & Shipping", 
    "App Experience", 
    "Store Experience", 
    "Product Effectiveness", 
    "Packaging", 
    "Side Effects", 
    "Ease of Use"
  ];
  
  // Generate 200 mock reviews
  const mockReviews = [
    // 1. Store Reviews (Google Reviews)
    {
      id: 1,
      userName: "Amit Verma",
      source: "Google Reviews",
      region: "North",
      city: "Delhi",
      date: "2024-04-20T10:00:25.377Z",
      rating: 5,
      sentiment: "Positive",
      categorySentiments: [
        { category: "Store Experience", sentiment: "Positive" },
        { category: "Customer Service", sentiment: "Positive" }
      ],
      reviewText: "Excellent product! Visited the store last week. The store was well-organized and clean. Customer support was very helpful.",
      replyStatus: "Replied",
      replyText: "Thank you for your feedback, Amit! We're glad you enjoyed your experience at our Delhi store.",
      replyDate: "2024-04-21T09:15:25.377Z"
    },
    {
      id: 2,
      userName: "Priya Sharma",
      source: "Google Reviews",
      region: "South",
      city: "Bangalore",
      date: "2024-05-15T14:25:32.255Z",
      rating: 2,
      sentiment: "Negative",
      categorySentiments: [
        { category: "Store Experience", sentiment: "Negative" },
        { category: "Customer Service", sentiment: "Negative" }
      ],
      reviewText: "Disappointing experience. Visited the store last week. The store was messy and disorganized. Customer service needs improvement.",
      replyStatus: "Replied",
      replyText: "We apologize for your experience, Priya. We're working to improve our Bangalore store services. Please reach out to our customer care for any specific concerns.",
      replyDate: "2024-05-16T10:30:15.422Z"
    },
    {
      id: 3,
      userName: "Raj Kumar",
      source: "Google Reviews",
      region: "West 1",
      city: "Mumbai",
      date: "2024-06-03T11:45:19.633Z",
      rating: 4,
      sentiment: "Positive",
      categorySentiments: [
        { category: "Store Experience", sentiment: "Positive" },
        { category: "Product Quality", sentiment: "Positive" }
      ],
      reviewText: "Great store layout and helpful staff. Visited the store last week. The store was well-organized and clean. The quality is excellent.",
      replyStatus: "Not Replied",
      replyText: null,
      replyDate: null
    },
    {
      id: 4,
      userName: "Neha Patel",
      source: "Google Reviews",
      region: "East 1",
      city: "Kolkata",
      date: "2024-07-12T09:30:45.128Z",
      rating: 3,
      sentiment: "Neutral",
      categorySentiments: [
        { category: "Store Experience", sentiment: "Positive" },
        { category: "Price & Value", sentiment: "Negative" }
      ],
      reviewText: "Store was nice but products seemed overpriced. Visited the store last week. The store was well-organized and clean. It's too expensive for what you get.",
      replyStatus: "Replied",
      replyText: "Thank you for your feedback, Neha. We value your input on our pricing and will take it into consideration.",
      replyDate: "2024-07-13T14:20:33.782Z"
    },
    {
      id: 5,
      userName: "Vikram Singh",
      source: "Google Reviews",
      region: "North 2",
      city: "Chandigarh",
      date: "2024-08-05T16:15:22.441Z",
      rating: 5,
      sentiment: "Positive",
      categorySentiments: [
        { category: "Store Experience", sentiment: "Positive" },
        { category: "Customer Service", sentiment: "Positive" },
        { category: "Product Quality", sentiment: "Positive" }
      ],
      reviewText: "Excellent overall experience! Visited the store last week. The store was well-organized and clean. Customer support was very helpful. The quality is excellent.",
      replyStatus: "Replied",
      replyText: "We appreciate your wonderful review, Vikram! Thank you for shopping with us in Chandigarh.",
      replyDate: "2024-08-06T11:05:18.319Z"
    },
    
    // 2. App Store Reviews
    {
      id: 6,
      userName: "Ananya Reddy",
      source: "App Store",
      region: "South",
      city: "Hyderabad",
      date: "2024-05-22T13:40:36.552Z",
      rating: 5,
      sentiment: "Positive",
      categorySentiments: [
        { category: "App Experience", sentiment: "Positive" },
        { category: "Ease of Use", sentiment: "Positive" }
      ],
      reviewText: "Love the new app update! Been using the app for a month now. The app is very user-friendly. Very easy to incorporate into my routine.",
      replyStatus: "Replied",
      replyText: "Thank you for your feedback, Ananya! We're glad you're enjoying our app's new features.",
      replyDate: "2024-05-23T09:10:42.783Z"
    },
    {
      id: 7,
      userName: "Karan Joshi",
      source: "App Store",
      region: "West",
      city: "Ahmedabad",
      date: "2024-06-14T10:22:15.331Z",
      rating: 2,
      sentiment: "Negative",
      categorySentiments: [
        { category: "App Experience", sentiment: "Negative" }
      ],
      reviewText: "App keeps crashing. Been using the app for a month now. The app keeps crashing.",
      replyStatus: "Replied",
      replyText: "We're sorry to hear about your experience, Karan. Our team is working to fix these issues. Please update to the latest version.",
      replyDate: "2024-06-15T08:35:27.129Z"
    },
    {
      id: 8,
      userName: "Meera Gupta",
      source: "App Store",
      region: "East",
      city: "Patna",
      date: "2024-07-20T15:18:42.238Z",
      rating: 4,
      sentiment: "Positive",
      categorySentiments: [
        { category: "App Experience", sentiment: "Positive" },
        { category: "Product Quality", sentiment: "Positive" }
      ],
      reviewText: "Great app, easy to navigate. Been using the app for a month now. The app is very user-friendly. The quality is excellent.",
      replyStatus: "Not Replied",
      replyText: null,
      replyDate: null
    },
    {
      id: 9,
      userName: "Arjun Mehta",
      source: "App Store",
      region: "North 1",
      city: "Gurugram",
      date: "2024-08-11T09:05:33.127Z",
      rating: 3,
      sentiment: "Neutral",
      categorySentiments: [
        { category: "App Experience", sentiment: "Positive" },
        { category: "Product Effectiveness", sentiment: "Negative" }
      ],
      reviewText: "App works well but product results are mixed. Been using the app for a month now. The app is very user-friendly. Didn't see the results I expected.",
      replyStatus: "Replied",
      replyText: "Thank you for your feedback, Arjun. We'd love to hear more about your experience with our products. Please contact our customer service team.",
      replyDate: "2024-08-12T14:22:18.556Z"
    },
    {
      id: 10,
      userName: "Divya Nair",
      source: "App Store",
      region: "South 1",
      city: "Chennai",
      date: "2024-09-05T11:30:27.442Z",
      rating: 5,
      sentiment: "Positive",
      categorySentiments: [
        { category: "App Experience", sentiment: "Positive" },
        { category: "Customer Service", sentiment: "Positive" }
      ],
      reviewText: "The app is fantastic! Been using the app for a month now. The app is very user-friendly. Customer support was very helpful.",
      replyStatus: "Replied",
      replyText: "We're thrilled you're enjoying our app, Divya! Thank you for the kind words.",
      replyDate: "2024-09-06T10:15:42.781Z"
    },
    
    // 3. Play Store Reviews
    {
      id: 11,
      userName: "Rahul Verma",
      source: "Play Store",
      region: "West 2",
      city: "Surat",
      date: "2024-05-18T10:42:33.662Z",
      rating: 4,
      sentiment: "Positive",
      categorySentiments: [
        { category: "App Experience", sentiment: "Positive" }
      ],
      reviewText: "Solid app with great features. Been using the app for a month now. The app is very user-friendly.",
      replyStatus: "Replied",
      replyText: "Thank you for your feedback, Rahul! We're glad you're enjoying our app.",
      replyDate: "2024-05-19T09:20:15.337Z"
    },
    {
      id: 12,
      userName: "Sneha Iyer",
      source: "Play Store",
      region: "South 2",
      city: "Kochi",
      date: "2024-06-24T14:15:52.229Z",
      rating: 1,
      sentiment: "Negative",
      categorySentiments: [
        { category: "App Experience", sentiment: "Negative" },
        { category: "Customer Service", sentiment: "Negative" }
      ],
      reviewText: "Terrible app experience. Been using the app for a month now. The app keeps crashing. Customer service needs improvement.",
      replyStatus: "Replied",
      replyText: "We apologize for your experience, Sneha. Our team is working to resolve these issues. Please try updating to the latest version.",
      replyDate: "2024-06-25T10:30:18.456Z"
    },
    {
      id: 13,
      userName: "Aditya Shah",
      source: "Play Store",
      region: "East 2",
      city: "Ranchi",
      date: "2024-07-30T09:25:44.338Z",
      rating: 3,
      sentiment: "Neutral",
      categorySentiments: [
        { category: "App Experience", sentiment: "Neutral" },
        { category: "Product Effectiveness", sentiment: "Positive" }
      ],
      reviewText: "App needs improvement but products are good. Been using the app for a month now. This aspect needs improvement. Saw results within days.",
      replyStatus: "Not Replied",
      replyText: null,
      replyDate: null
    },
    {
      id: 14,
      userName: "Pooja Sharma",
      source: "Play Store",
      region: "North",
      city: "Jaipur",
      date: "2024-08-14T15:38:22.449Z",
      rating: 5,
      sentiment: "Positive",
      categorySentiments: [
        { category: "App Experience", sentiment: "Positive" },
        { category: "Ease of Use", sentiment: "Positive" },
        { category: "Product Effectiveness", sentiment: "Positive" }
      ],
      reviewText: "Fantastic app and great results! Been using the app for a month now. The app is very user-friendly. Very easy to incorporate into my routine. Saw results within days.",
      replyStatus: "Replied",
      replyText: "Thank you for your wonderful review, Pooja! We're thrilled you're getting great results.",
      replyDate: "2024-08-15T11:20:35.781Z"
    },
    {
      id: 15,
      userName: "Akshay Kumar",
      source: "Play Store",
      region: "West 1",
      city: "Pune",
      date: "2024-09-10T11:55:37.229Z",
      rating: 4,
      sentiment: "Positive",
      categorySentiments: [
        { category: "App Experience", sentiment: "Positive" },
        { category: "Product Quality", sentiment: "Positive" }
      ],
      reviewText: "Useful app with quality products. Been using the app for a month now. The app is very user-friendly. The quality is excellent.",
      replyStatus: "Not Replied",
      replyText: null,
      replyDate: null
    },
    
    // 4. Amazon Reviews
    {
      id: 16,
      userName: "Anjali Gupta",
      source: "Amazon",
      region: "North 2",
      city: "Shimla",
      date: "2024-05-25T09:30:42.581Z",
      rating: 5,
      sentiment: "Positive",
      categorySentiments: [
        { category: "Product Quality", sentiment: "Positive" },
        { category: "Product Effectiveness", sentiment: "Positive" },
        { category: "Packaging", sentiment: "Positive" }
      ],
      reviewText: "Amazing product, works wonders! Purchased this product after reading other reviews. The quality is excellent. Saw results within days. Packaging is elegant and secure.",
      replyStatus: "Replied",
      replyText: "Thank you for your wonderful review, Anjali! We're thrilled you're happy with our product.",
      replyDate: "2024-05-26T10:15:22.337Z"
    },
    {
      id: 17,
      userName: "Vikas Patel",
      source: "Amazon",
      region: "West",
      city: "Surat",
      date: "2024-06-18T14:22:36.447Z",
      rating: 2,
      sentiment: "Negative",
      categorySentiments: [
        { category: "Product Quality", sentiment: "Negative" },
        { category: "Price & Value", sentiment: "Negative" }
      ],
      reviewText: "Not worth the money. Purchased this product after reading other reviews. The quality could be better. It's too expensive for what you get.",
      replyStatus: "Replied",
      replyText: "We're sorry to hear you weren't satisfied, Vikas. Please contact our customer service for a possible resolution.",
      replyDate: "2024-06-19T11:30:25.781Z"
    },
    {
      id: 18,
      userName: "Sunita Reddy",
      source: "Amazon",
      region: "South",
      city: "Hyderabad",
      date: "2024-07-09T10:18:33.229Z",
      rating: 4,
      sentiment: "Positive",
      categorySentiments: [
        { category: "Product Effectiveness", sentiment: "Positive" },
        { category: "Side Effects", sentiment: "Negative" }
      ],
      reviewText: "Good results but minor side effects. Purchased this product after reading other reviews. Saw results within days. I experienced some mild side effects.",
      replyStatus: "Replied",
      replyText: "Thank you for your feedback, Sunita. We'd like to learn more about your experience with side effects. Please contact our health support team.",
      replyDate: "2024-07-10T09:25:42.118Z"
    },
    {
      id: 19,
      userName: "Rajiv Mehta",
      source: "Amazon",
      region: "East 1",
      city: "Siliguri",
      date: "2024-08-20T15:40:27.338Z",
      rating: 1,
      sentiment: "Negative",
      categorySentiments: [
        { category: "Delivery & Shipping", sentiment: "Negative" },
        { category: "Packaging", sentiment: "Negative" }
      ],
      reviewText: "Product arrived damaged. Purchased this product after reading other reviews. Shipping took too long. The packaging was damaged upon arrival.",
      replyStatus: "Replied",
      replyText: "We sincerely apologize for this experience, Rajiv. Please contact our customer service immediately for a replacement.",
      replyDate: "2024-08-21T10:15:33.227Z"
    },
    {
      id: 20,
      userName: "Deepa Joshi",
      source: "Amazon",
      region: "South 1",
      city: "Madurai",
      date: "2024-09-15T11:25:38.449Z",
      rating: 5,
      sentiment: "Positive",
      categorySentiments: [
        { category: "Product Quality", sentiment: "Positive" },
        { category: "Product Effectiveness", sentiment: "Positive" },
        { category: "Delivery & Shipping", sentiment: "Positive" }
      ],
      reviewText: "Excellent product and fast delivery! Purchased this product after reading other reviews. The quality is excellent. Saw results within days. Arrived faster than expected.",
      replyStatus: "Not Replied",
      replyText: null,
      replyDate: null
    }
  ];
  
  // Generate remaining 180 reviews to make a total of 200
  function generateMoreReviews() {
    const sources = ["Google Reviews", "App Store", "Play Store", "Amazon"];
    const sentiments = ["Positive", "Negative", "Neutral"];
    const replyStatuses = ["Replied", "Not Replied"];
    const userFirstNames = ["Arun", "Priya", "Vikram", "Neha", "Rahul", "Anjali", "Sandeep", "Kavita", "Ajay", "Divya", "Rohan", "Meena", "Arjun", "Pooja", "Alok", "Suman"];
    const userLastNames = ["Sharma", "Patel", "Singh", "Gupta", "Reddy", "Kumar", "Shah", "Joshi", "Mehta", "Nair", "Verma", "Iyer", "Rao", "Kapoor", "Malhotra", "Banerjee"];
    
    // Positive review templates
    const positiveReviews = [
      "Great product! Very satisfied with my purchase.",
      "Excellent quality and value for money.",
      "Works exactly as described. Highly recommend!",
      "Amazing results within just a few weeks of use.",
      "The store experience was fantastic. Staff is very knowledgeable.",
      "App is easy to use and has all the features I need.",
      "Fast delivery and product was well packaged.",
      "Customer service was exceptional. Helped resolve my issue quickly.",
      "Noticeable improvement in my health after using this product.",
      "No side effects and great results. Very happy!"
    ];
    
    // Negative review templates
    const negativeReviews = [
      "Disappointed with the quality. Expected better.",
      "Overpriced for what you get. Not worth it.",
      "Product didn't work as advertised for me.",
      "The app keeps crashing. Needs improvement.",
      "Slow delivery and packaging was damaged.",
      "Customer service was unhelpful with my issue.",
      "Experienced some unpleasant side effects.",
      "Store staff was rude and not knowledgeable.",
      "No noticeable results after weeks of use.",
      "App interface is confusing and difficult to navigate."
    ];
    
    // Neutral review templates
    const neutralReviews = [
      "Product is okay. Nothing special but does the job.",
      "App works fine most of the time with occasional glitches.",
      "Average product for the price point.",
      "Some features are good, others need improvement.",
      "Store experience was standard, nothing exceptional.",
      "Got mixed results with this product.",
      "Delivery was on time but packaging could be better.",
      "Works for some issues but not others.",
      "Customer service was responsive but couldn't fully resolve my issue.",
      "Good value but similar products available at better prices."
    ];
    
    const additionalReviews = [];
    
    for (let i = 21; i <= 200; i++) {
      // Select random region and city
      const regionKey = Object.keys(regions)[Math.floor(Math.random() * Object.keys(regions).length)];
      const city = regions[regionKey][Math.floor(Math.random() * regions[regionKey].length)];
      
      // Select random source
      const source = sources[Math.floor(Math.random() * sources.length)];
      
      // Select random sentiment
      const sentiment = sentiments[Math.floor(Math.random() * sentiments.length)];
      
      // Determine rating based on sentiment
      let rating;
      if (sentiment === "Positive") {
        rating = 4 + Math.floor(Math.random() * 2); // 4 or 5
      } else if (sentiment === "Negative") {
        rating = 1 + Math.floor(Math.random() * 2); // 1 or 2
      } else {
        rating = 3; // Neutral
      }
      
      // Select random reply status
      const replyStatus = replyStatuses[Math.floor(Math.random() * replyStatuses.length)];
      
      // Generate random date within last year
      const now = new Date();
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(now.getFullYear() - 1);
      const reviewDate = new Date(oneYearAgo.getTime() + Math.random() * (now.getTime() - oneYearAgo.getTime()));
      
      // Generate random user name
      const firstName = userFirstNames[Math.floor(Math.random() * userFirstNames.length)];
      const lastName = userLastNames[Math.floor(Math.random() * userLastNames.length)];
      const userName = `${firstName} ${lastName}`;
      
      // Generate 1-3 random category sentiments
      const numCategories = 1 + Math.floor(Math.random() * 3); // 1, 2, or 3
      const selectedCategories = new Set();
      const categorySentiments = [];
      
      for (let j = 0; j < numCategories; j++) {
        let category;
        do {
          category = categories[Math.floor(Math.random() * categories.length)];
        } while (selectedCategories.has(category));
        
        selectedCategories.add(category);
        const catSentiment = Math.random() < 0.7 ? sentiment : sentiments[Math.floor(Math.random() * sentiments.length)];
        
        categorySentiments.push({
          category: category,
          sentiment: catSentiment
        });
      }
      
      // Generate review text based on sentiment
      let reviewText;
      if (sentiment === "Positive") {
        reviewText = positiveReviews[Math.floor(Math.random() * positiveReviews.length)];
      } else if (sentiment === "Negative") {
        reviewText = negativeReviews[Math.floor(Math.random() * negativeReviews.length)];
      } else {
        reviewText = neutralReviews[Math.floor(Math.random() * neutralReviews.length)];
      }
      
      // Add source-specific prefix
      if (source === "Amazon") {
        reviewText = `${reviewText} Purchased this product based on recommendations.`;
      } else if (source === "Google Reviews") {
        reviewText = `${reviewText} Visited their store recently.`;
      } else {
        reviewText = `${reviewText} Been using the app for a few weeks.`;
      }
      
      // Create review object
      const review = {
        id: i,
        userName: userName,
        source: source,
        region: regionKey,
        city: city,
        date: reviewDate.toISOString(),
        rating: rating,
        sentiment: sentiment,
        categorySentiments: categorySentiments,
        reviewText: reviewText,
        replyStatus: replyStatus,
        replyText: replyStatus === "Replied" ? "Thank you for your feedback. We appreciate your input and will use it to improve our services." : null,
        replyDate: replyStatus === "Replied" ? new Date(reviewDate.getTime() + (1 + Math.random() * 3) * 24 * 60 * 60 * 1000).toISOString() : null // Reply within 1-4 days
      };
      
      additionalReviews.push(review);
    }
    
    return additionalReviews;
  }
  
  // Combine the initial reviews with the generated ones
  const remainingReviews = generateMoreReviews();
  const allReviews = [...mockReviews, ...remainingReviews];
  
  // Export the mock data
  const mockData = {
    regions,
    categories,
    reviews: allReviews
  };
  
// Generate NPS data
const generateNpsData = () => {
  // Current date
  const now = new Date();
  
  // Create 50 NPS responses across the last 6 months
  const npsResponses = [];
  
  // User first and last names for random user generation
  const userFirstNames = ["Arun", "Priya", "Vikram", "Neha", "Rahul", "Anjali", "Sandeep", "Kavita", "Ajay", "Divya"];
  const userLastNames = ["Sharma", "Patel", "Singh", "Gupta", "Reddy", "Kumar", "Shah", "Joshi", "Mehta", "Nair"];
  
  // NPS score distributions - weighted towards higher scores
  const npsScores = [
    // 0-6 (Detractors): ~20%
    0, 1, 2, 3, 4, 5, 6, 0, 3, 5,
    // 7-8 (Passives): ~30%
    7, 8, 7, 8, 7, 7, 8, 8, 7, 8, 7, 8, 7, 7, 8,
    // 9-10 (Promoters): ~50% 
    9, 10, 9, 10, 9, 10, 9, 10, 9, 9, 10, 10, 9, 10, 9, 10, 9, 9, 10, 10, 9, 10, 9, 10, 9
  ];
  
  // Sample products
  const products = [
    "Product Original", 
    "Product Premium", 
    "Product Max", 
    "Product Everyday", 
    "Product Complete"
  ];
  
  // Sample regions and cities (using similar structure as original data)
  const regions = {
    "North": ["Delhi", "Chandigarh", "Lucknow", "Jaipur"],
    "East": ["Kolkata", "Patna", "Bhubaneswar", "Guwahati"],
    "West": ["Mumbai", "Pune", "Ahmedabad", "Surat"],
    "South": ["Chennai", "Bangalore", "Hyderabad", "Kochi"]
  };
  
  // Feedback templates for different score ranges
  const detractorFeedback = [
    "Not satisfied with the product quality. Wouldn't recommend.",
    "Disappointed with the results. Expected better for the price.",
    "Customer service was very poor when I had issues.",
    "Product didn't work as advertised for me.",
    "The shipping was delayed and packaging was damaged.",
    "Had issues with the product that were never resolved."
  ];
  
  const passiveFeedback = [
    "Product is okay. Nothing special but does the job.",
    "Reasonable quality for the price. Might buy again.",
    "Customer service was helpful but took time to resolve my issue.",
    "Average experience. Some things could be improved.",
    "Product works but takes longer than expected to see results.",
    "Decent product but there are similar options at better prices."
  ];
  
  const promoterFeedback = [
    "Excellent product! Exceeded my expectations.",
    "Very satisfied with my purchase. Will definitely buy again.",
    "Customer service was exceptional. Helped resolve my issue quickly.",
    "Amazing results within just a few weeks of use.",
    "Best product I've used in this category. Highly recommend!",
    "Great value for money. The quality is outstanding."
  ];
  
  // Generate NPS responses
  for (let i = 1; i <= 50; i++) {
    // Random date in last 6 months
    const randomDays = Math.floor(Math.random() * 180);
    const responseDate = new Date(now);
    responseDate.setDate(responseDate.getDate() - randomDays);
    
    // Random user
    const firstName = userFirstNames[Math.floor(Math.random() * userFirstNames.length)];
    const lastName = userLastNames[Math.floor(Math.random() * userLastNames.length)];
    const userName = `${firstName} ${lastName}`;
    
    // Random NPS score
    const npsScore = npsScores[Math.floor(Math.random() * npsScores.length)];
    
    // Determine sentiment based on NPS score
    let sentiment;
    let feedback;
    
    if (npsScore >= 0 && npsScore <= 6) {
      sentiment = "Negative";
      feedback = detractorFeedback[Math.floor(Math.random() * detractorFeedback.length)];
    } else if (npsScore >= 7 && npsScore <= 8) {
      sentiment = "Neutral";
      feedback = passiveFeedback[Math.floor(Math.random() * passiveFeedback.length)];
    } else {
      sentiment = "Positive";
      feedback = promoterFeedback[Math.floor(Math.random() * promoterFeedback.length)];
    }
    
    // Random region and city
    const regionKeys = Object.keys(regions);
    const randomRegion = regionKeys[Math.floor(Math.random() * regionKeys.length)];
    const cities = regions[randomRegion];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    
    // Random product
    const randomProduct = products[Math.floor(Math.random() * products.length)];
    
    // Create NPS response
    const npsResponse = {
      id: 1000 + i, // Start IDs at 1000 to avoid collisions with existing data
      userName: userName,
      source: "NPS",
      region: randomRegion,
      city: randomCity,
      date: responseDate.toISOString(),
      npsScore: npsScore,
      rating: Math.ceil(npsScore / 2), // Convert NPS to 5-star rating for compatibility
      sentiment: sentiment,
      categorySentiments: [
        { category: "Product Quality", sentiment: sentiment },
        { category: "Product Effectiveness", sentiment: sentiment }
      ],
      reviewText: feedback + ` (Product: ${randomProduct})`,
      product: randomProduct,
      replyStatus: Math.random() > 0.3 ? "Replied" : "Not Replied", // 70% replied
      replyText: Math.random() > 0.3 ? "Thank you for your feedback. We appreciate your input and will use it to improve our services." : null,
      replyDate: Math.random() > 0.3 ? new Date(responseDate.getTime() + (1 + Math.random() * 3) * 24 * 60 * 60 * 1000).toISOString() : null
    };
    
    npsResponses.push(npsResponse);
  }
  
  return npsResponses;
};

  mockData.generateNpsData = generateNpsData

  // In a real environment, we would export this
  // For now, we'll just make it available globally
  window.livpureMockData = mockData;
  export const livpureMockData = mockData;